import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { generate } from "random-words";
import { ProjectData } from '../../shared/shared.module';
interface ApiResponse {
  [key: string]: any;
}

@Component({
  selector: 'app-brief',
  templateUrl: './brief.component.html',
  styleUrls: ['./brief.component.scss', '../project/overview/overview.component.scss'],
})
export class BriefComponent {
//   @ViewChild('messagesContainer', { static: true }) messagesContainer!: ElementRef;
//   @ViewChild('messageInput', { static: true }) messageInput!: ElementRef;
//   isClarifyDisabled = false; // Disable Clarify button after 3 clicks
//   clarifyClick = 0; // Track Clarify button clicks
//   isLoading = false; // Track loading state
//   isMessageValid = false; // Track if message has at least 40 characters
//   showValidationMessage = false; // Show validation message if message is too short
//   getVendors = false;
//   isRolesContainerVisible: boolean = false; // Add a property to track the visibility of the roles container
  // concatenatedUserMessages: string = ''; 
  // -------------------------------------------------
  // @Output() projectCreated = new EventEmitter<any>();
//  onProjectCreated(projectData: any) {
    // this.projectCreated.emit(projectData);
  // }
  // ---------------------------
//   skillsData: string = '';
//   // Form fields
//   clientName: string = ''; // Initialize as empty
//   deliveryDate: Date | undefined; // Initialize as empty
//   budget: string = ''; // Initialize as empty
//   contact: string = ''; // Initialize as empty
//   phone: string = ''; // Initialize as empty
//   email: string = ''; // Initialize as empty
//   brief: string = ''; // Initialize as empty
//   inPersonMeeting:string = '';
  
//   prompts = [
//     "Generate a title (max 6 words) as valid JSON: { \"title\": \"<string>\" }",
//     "Detect the project type Each project entry may include an informal or detailed sub-category (photoshoot ,film shooting). Your job is to identify the correct main category based on the mapping below and replace the sub-category with the standardized category label as Use the following mapping rules: ( 'photoshoot', 'photo shoot', 'party photo shoot',Linked Sub-services: Lifestyle Shoot, People & Scene, Product Shoot, Manufacturing/Industrial/Real Estate Shoot, Event Shoot, Food Shoot) as Photography ('film shooting', 'movie shoot', 'TVC', 'corporate film', 'training film', 'event film', 'social media film')as Film Making ('voice over', 'narration', 'dubbing', 'localization', 'character portrayals')as Audio ('logo design', 'poster design', 'product design', 'social media design', 'brand identity', 'architecture design')as Graphics & Designing and ('2D animation', '3D animation', 'CGI', 'VFX', 'compositing', 'particle effects', '3D modeling', 'rigging') as CGI/VFX valid JSON: { \"type\": \"<string>\" }",
//     "List skills as valid JSON: { \"skills\": [ { \"name\": \"<string>\", \"description\": \"<string>\", \"deliverables\": [ { \"name\": \"<string>\", \"description\": \"<string>\", \"effort_in_hours\": <number>, \"cost_in_rupees\": <number> } ] } ] }",
//     "List roles as valid JSON: { \"roles\": [ { \"name\": \"<string>\", \"description\": \"<string>\", \"skill_name\":  \"<string>\", \"deliverables\": [ { \"name\": \"<string>\", \"description\": \"<string>\", \"effort_in_hours\": <number>, \"cost_in_rupees\": <number> } ] } ] }",
//     "List references mentioned in the prompt as valid JSON: { \"references\": [ { \"name\": \"<string>\", \"description\": \"<string>\", \"url\": \"<string>\" } ] }. If none, return { \"references\": [] }."
// ];

//   constructor(
//     private apiService: ApiService,
//     private renderer: Renderer2,
//     private router: Router
//   ) {}  

//   closeRolesPopup() {
//     this.isRolesContainerVisible = false;
//   }

//   dateFilter = (date: Date | null): boolean => {
//     if (!date) return false;
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     return date >= today;
//   };

//   onMessageInput(): void {
//     this.isMessageValid = this.brief.length >= 40;
//     this.showValidationMessage = !this.isMessageValid;
//   }

//   sendMessage(event: Event): void {
//     event.preventDefault();
//     if (!this.brief || !this.isMessageValid) return;

//     this.clarifyClick++;
//     if (this.clarifyClick >= 3) {
//       this.isClarifyDisabled = true;
//     }

//     const previousClarifications = this.messagesContainer.nativeElement.querySelectorAll('.badge');
//     previousClarifications.forEach((badge: HTMLElement) => {
//       this.renderer.removeChild(this.messagesContainer.nativeElement, badge);
//     });

//     this.isLoading = true;

//     const fullMessage = `
//       Client Name: ${this.clientName}
//       Delivery Date: ${this.deliveryDate}
//       Budget: ${this.budget}
//       Contact: ${this.contact}
//       Phone: ${this.phone}
//       Email: ${this.email}
//       Message: ${this.brief}
//     `;

//     this.apiService.post<ApiResponse>('clarification', { content: this.concatenatedUserMessages }).subscribe({
//       next: (res) => {
//         this.isLoading = false;
//         const keys = Object.keys(res);
//         const clarifications = Array.isArray(res[keys[0]]) ? res[keys[0]] : [{ name: res['name'], description: res['description'] }];
//         clarifications.forEach((item: { name: string; description: string }) => {
//           const clarificationSpan = this.renderer.createElement('span');
//           this.renderer.addClass(clarificationSpan, 'badge');
//           this.renderer.setAttribute(clarificationSpan, 'title', item.description || '');
//           const clarificationText = this.renderer.createText(item.name || '');
//           this.renderer.appendChild(clarificationSpan, clarificationText);
//           this.renderer.appendChild(this.messagesContainer.nativeElement, clarificationSpan);
//         });
//       },
//       error: (error) => {
//         this.isLoading = false;
//         console.error('API Error:', error);
//       },
//     });
//   }

//   project(event: Event): void {
//     event.preventDefault();
//     if (!this.brief || !this.isMessageValid) return;

//     this.isLoading = true;
//     const responses: any[] = [];

//     const makeApiCall = (index: number) => {
//       if (index >= this.prompts.length) {
//         this.isLoading = false;
//         const cleanedResponses = responses.map(this.cleanUpResponse);
//         const dataToStore = {
//           title: cleanedResponses[0],
//           type: cleanedResponses[1],
//           skills: cleanedResponses[2],
//         };
//         this.skillsData = cleanedResponses[2];
//         console.log('Skills:', cleanedResponses[2]);
//         return this.skillsData;
//       }

//       const apiCall = this.apiService.post<ApiResponse>('project/summary', {
//         content: this.concatenatedUserMessages,
//         prompt: this.prompts[index],
//       });

//       apiCall.subscribe({
//         next: (res) => {
//           responses.push(res);
//           makeApiCall(index + 1);
//         },
//         error: (error) => {
//           this.isLoading = false;
//           console.error('API Error:', error);
//           return; // Add return statement here
//         },
//       });

//       return; // Add return statement here
//     };

//     makeApiCall(0);
//   }

//   submitForm(event: Event): void {
//     const userInfoString = localStorage.getItem('userInfo');
//     if (!userInfoString) {
//       console.error('User info not found in localStorage');
//       return;
//     }

//     const userInfo = JSON.parse(userInfoString);
//     const userName = userInfo.name || 'Unknown User';
//     const visibility = userInfo['custom:visibility'] || 'global';
//     const team = userInfo['custom:team'] || 'Unknown Team';
//     const phone = userInfo.phone_number || 'Unknown Phone';
//     const email = userInfo.email || 'Unknown Email';
//     event.preventDefault();

//     if (!this.brief || !this.isMessageValid) return;

//     this.isLoading = true;

//     const fullMessage = `
//       Client Name: ${this.clientName}
//       Delivery Date: ${this.deliveryDate}
//       Budget: ${this.budget}
//       Message: ${this.brief}
//     `;

//     const additionalApis = [
//       // { endpoint: 'project/create-plan', key: 'plan' },
//       // { endpoint: 'project/create-plan?cost=true', key: 'planWithCost' }, // New API call with cost
//       // { endpoint: 'project/create-terms-engagement', key: 'termsEngagement' },
//        { endpoint: 'project/create-scope-of-work', key: 'scope_of_work', needsCustomerName: false },
//       { endpoint: 'project/create-timeline', key: 'timeline', needsCustomerName: false },
//       { endpoint: 'project/create-hiring-summary', key: 'hiring_summary', needsCustomerName: false },
//     ];

//     const responses: any[] = [];

//     const makeApiCall = (index: number) => {
//       console.log(additionalApis,"additionalApis");
//       if (index >= this.prompts.length + additionalApis.length) {
//         this.isLoading = false;
//         const uuid = generate({ minLength: 5, maxLength: 7 }) + '-' + generate({ minLength: 5, maxLength: 7 });
//         const cleanedResponses = responses.map(this.cleanUpResponse);

//         console.log(cleanedResponses,"Test final res");
        

//         const dataToStore: ProjectData = {
//           id: uuid,
//           customer: this.clientName,
//           deliveryDate: this.deliveryDate || new Date(),
//           budget: this.budget,
//           contact: this.contact,
//           phone: this.phone,
//           email: this.email,
//           brief: this.brief,
//           inPersonMeeting: this.inPersonMeeting,
//           createdDate: new Date().toISOString(),
//           lead: team,
//           stgplan: true,
//           stgres: false,
//           stgdel: false,
//           title: cleanedResponses[0],
//           type: cleanedResponses[1],
//           skills: cleanedResponses[2],
//           roles: cleanedResponses[3], // Assign the roles response here
//           references: cleanedResponses[4],
//           // plan: cleanedResponses[5],
//           // planWithCost: cleanedResponses[6], // New key for plan with cost
//           // termsEngagement: cleanedResponses[7],
//           scope_of_work: cleanedResponses[5],
//           timeline: cleanedResponses[6],
//           hiring_summary:cleanedResponses[7],
//           deliverables: [],
//           completed: false,
//           cost: 0,
//           internalCost: 0,
//           vendorCost: 0,
//           toeAccepted: false,
//           status: 'In Progress',
//           location: '',
//           owner: {
//             name: userName,
//             visibility: visibility,
//             team: team,
//             phone: phone,
//             email: email,
//           },
//           created_by: email,
//           notifications: [],
//         };

//         this.apiService.post('projects', dataToStore).subscribe({
//           next: (res) => {
//             console.log('Data stored in database:', res);
//             const emailData = {
//               mailto: userInfo.email,
//               customer_name: this.clientName,
//               projectid: uuid,
//               projectbrief: this.brief,
//               project_url: `http://uat.studioip.in/workspace/project/${uuid}`,
//             };

//             this.apiService.post('projects/project-created', emailData).subscribe({
//               next: (emailRes) => {
//                 console.log('Email sent successfully:', emailRes);
//                 this.router.navigate(['workspace/brief']);
//               },
//               error: (emailError) => {
//                 console.error('Error sending email:', emailError);
//                 this.router.navigate(['workspace/brief']);
//               },
//             });
//           },
//           error: (error) => {
//             console.error('Error storing data in database:', error);
//           },
//         });
//         return;
//       }

//       let apiCall;
//       if (index < this.prompts.length) {
//         apiCall = this.apiService.post<ApiResponse>('project/summary', {
//           content: fullMessage,
//           prompt: this.prompts[index],
//         });
//       } else {
//         const apiIndex = index - this.prompts.length;
//         apiCall = this.apiService.post<ApiResponse>(additionalApis[apiIndex].endpoint, { content: fullMessage });
//       }

//       apiCall.subscribe({
//         next: (res) => {
//           responses.push(res);
//           makeApiCall(index + 1);
//         },
//         error: (error) => {
//           this.isLoading = false;
//           console.error('API Error:', error);
//         },
//       });
//     };

//     makeApiCall(0);
//   }

//   private cleanUpResponse(response: any): any {
//     if (response && typeof response === 'object') {
//       const keys = Object.keys(response);
//       if (keys.length === 1) {
//         return response[keys[0]];
//       }
//     }
//     return response;
//   }
}